import { Directive, Output, EventEmitter, HostListener, Input } from '@angular/core';
import { HoveredEvent } from './hovered.interfaces';

@Directive({
  selector: '[appHovered]'
})
export class HoveredDirective {
  @Output() appHovered = new EventEmitter<HoveredEvent>();
  @Input() hoverData: any;

  constructor() { }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event) {
    this.appHovered.emit({
      event,
      hovered: true,
      data: this.hoverData
    });
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event) {
    this.appHovered.emit({
      event,
      hovered: false,
      data: this.hoverData
    });
  }
}
